import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { CapabilityEngineService } from '../capabilityEngine.service';

@Injectable()
export class UserGuideService {

    constructor(
        private http: HttpClient,
        private _capEngineService: CapabilityEngineService
    ) { }

    updateTutorialSetting(obj) {
        return this.http.put(environment.serverUrl + '/user/preferences', obj);
    }
}



// WEBPACK FOOTER //
// ./src/app/user-guide/user-guide.service.ts